export const FirebaseMessaging = ({ children }) => children;
